export default __webpack_public_path__ + "static/media/noData.1ee17fc9.png";